import styled, { keyframes } from 'styled-components'

export const fade = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`

export const FadeIn = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background: #000000;
  animation: ${fade} 4s normal forwards ease-in-out;
`

export const Container = styled.div`
  font-family: 'Inter';
  font-size: 16px;
  color: white;
  & h1 {
    padding: 0;
    margin: 0 0 0.05em 0;
    color:white;
    font-family: 'Ayer Poster', serif;
    font-weight: 400;
    font-size: min(8vw, 14em);
    line-height: 0.85em;
    
    @media (max-width: 1400px) {
      font-size: min(8vw, 10em);
    }
    
    @media (max-width: 1200px) {
      font-size: min(9vw, 8em);
    }
    
    @media (max-width: 768px) {
      font-size: min(10vw, 5em);
    }
    
    @media (max-height: 800px) {
      font-size: min(8vw, 8em);
    }
    
    @media (max-height: 650px) {
      font-size: min(8vw, 6em);
    }
  }
`

export const TopLeft = styled.div`
  position: absolute;
  top: 5vw;
  left: 5vw;
  
  @media (max-width: 1400px) {
    top: 4vw;
    left: 4vw;
  }
  
  @media (max-width: 1200px) {
    top: 3vw;
    left: 3vw;
  }
  
  @media (max-width: 768px) {
    top: 4vw;
    left: 4vw;
  }
`

export const BottomLeft = styled.div`
  position: absolute;
  bottom: 5vw;
  font-size: 16px;
  left: 5vw;
  width: 50ch;
  max-width: 30%;
  
  @media (max-width: 1400px) {
    bottom: 4vw;
    left: 4vw;
  }
  
  @media (max-width: 1200px) {
    bottom: 3vw;
    left: 3vw;
    font-size: 14px;
  }
  
  @media (max-width: 768px) {
    bottom: 4vw;
    left: 4vw;
    font-size: 12px;
    max-width: 45%;
  }
`

export const BottomRight = styled.div`
  position: absolute;
  bottom: 5vw;
  right: 5vw;
  width: 35ch;
  max-width: 40%;
  line-height: 1em;
  letter-spacing: -0.01em;
  text-align: right;
  
  @media (max-width: 1400px) {
    bottom: 4vw;
    right: 4vw;
  }
  
  @media (max-width: 1200px) {
    bottom: 3vw;
    right: 3vw;
    font-size: 14px;
  }
  
  @media (max-width: 768px) {
    bottom: 4vw;
    right: 4vw;
    font-size: 12px;
    max-width: 50%;
  }
`

export const TopRight = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 5vw;
  bottom: 5vw;
  right: 5vw;
  text-align: right;
  
  @media (max-width: 1400px) {
    top: 4vw;
    bottom: 4vw;
    right: 4vw;
  }
  
  @media (max-width: 1200px) {
    top: 3vw;
    bottom: 3vw;
    right: 3vw;
  }
  
  @media (max-width: 768px) {
    top: 4vw;
    bottom: auto;
    right: 4vw;
    font-size: 12px;
  }
`

export const LeftMiddle = styled.div`
  position: absolute;
  bottom: 50%;
  right: 5vw;
  font-family: 'Inter';
  font-weight: 400;
  line-height: 1em;
  letter-spacing: -0.01em;
  font-size: 12px;
  transform: rotate(90deg) translate3d(50%, 0, 0);
  transform-origin: 100% 50%;
`

/* Tagline under the main title */
export const Tagline = styled.p`
  margin-top: 4em;
  
  @media (max-width: 1400px) {
    margin-top: 3em;
  }
  
  @media (max-width: 1200px) {
    margin-top: 2em;
  }
  
  @media (max-width: 768px) {
    margin-top: 1.5em;
    font-size: 14px;
  }
  
  @media (max-height: 800px) {
    margin-top: 2em;
  }
  
  @media (max-height: 650px) {
    margin-top: 1em;
  }
`

/* Section label for "Spotlight Projects:", "Our News:", "Latest Research:" */
export const SectionLabel = styled.p`
  font-size: 11pt;
  font-style: italic;
  color: white;
  margin: 0 0 0.5em 0;
`

/* Spotlight section in TopLeft - R&D projects */
export const SpotlightSection = styled.div`
  margin-top: 4em;
  padding-left: 0;
  margin-left: 0px;
  
  @media (max-width: 1400px) {
    margin-top: 3em;
  }
  
  @media (max-width: 1200px) {
    margin-top: 2em;
  }
  
  @media (max-height: 800px) {
    margin-top: 3em;
  }
  
  @media (max-height: 650px) {
    margin-top: 2.5em;
  }
`

export const SpotlightCaption = styled.p`
  font-size: 11pt;
  font-style: italic;
  color: white;
  margin-top: 0.5em;
  text-align: center;
  width: 385px;
  
  @media (max-width: 1400px) {
    width: 320px;
    font-size: 10pt;
  }
  
  @media (max-width: 1200px) {
    width: 260px;
    font-size: 9pt;
  }
  
  @media (max-height: 800px) {
    width: 280px;
    font-size: 10pt;
  }
  
  @media (max-height: 650px) {
    width: 200px;
    font-size: 9pt;
  }
`

export const CaptionLink = styled.a`
  color: white;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`

export const SpotlightLogo = styled.img`
  margin-top: 1.25em;
  height: ${props => props.$height || '300px'};
  width: ${props => props.$width || 'auto'};
  object-fit: contain;
  filter: saturate(0.5);
  transition: filter 0.3s ease;
  mask-image: radial-gradient(
    ellipse 50% 50% at center,
    black 60%,
    transparent 100%
  );
  -webkit-mask-image: radial-gradient(
    ellipse 50% 50% at center,
    black 60%,
    transparent 100%
  );
  
  &:hover {
    filter: saturate(1);
  }
  
  @media (max-width: 1400px) {
    max-width: 320px;
  }
  
  @media (max-width: 1200px) {
    max-width: 260px;
  }
  
  @media (max-height: 800px) {
    max-height: 180px;
    max-width: 280px;
  }
  
  @media (max-height: 650px) {
    max-height: 120px;
    max-width: 200px;
  }
`

/* News/Research section in TopRight */
export const NewsSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 6em;
  gap: 1em;
`

export const NewsItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.5em;
`

export const NewsLogo = styled.img`
  height: ${props => props.$height || '40px'};
  width: ${props => props.$width || '100px'};
`

export const NewsLink = styled.a`
  font-size: 11pt;
  font-style: italic;
  color: white;
  max-width: 140px;
  text-align: right;
`

export const ResearchSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: auto;
  margin-bottom: auto;
  gap: 0.5em;
  
  @media (max-height: 800px) {
    gap: 0.25em;
  }
  
  @media (max-height: 650px) {
    gap: 0.15em;
  }
`

export const ResearchLogo = styled.img`
  height: ${props => props.$height || '100px'};
  width: ${props => props.$width || '200px'};
  object-fit: contain;
  filter: saturate(0.5);
  transition: filter 0.3s ease;
  
  &:hover {
    filter: saturate(1);
  }
  
  @media (max-width: 1400px) {
    max-height: 180px;
    max-width: 180px;
  }
  
  @media (max-width: 1200px) {
    max-height: 140px;
    max-width: 150px;
  }
  
  @media (max-height: 800px) {
    max-height: 150px;
    max-width: 150px;
  }
  
  @media (max-height: 650px) {
    max-height: 100px;
    max-width: 120px;
  }
`

/* Email link styling */
export const EmailLink = styled.a`
  color: white;
`
